module.exports = __webpack_public_path__ + "static/media/design.1959a90a.jpg";